import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker, TimePicker } from '@material-ui/pickers';
import NativeSelect from '@material-ui/core/NativeSelect';
import {
  Button,
  Select,
  TextField,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormControl,
  InputLabel,
  InputAdornment,
  Grid,
  OutlinedInput,
  Paper,
  Typography
} from '@material-ui/core';
import {
  AddBox,
  RadioButtonUnchecked,
  RadioButtonChecked,
  CalendarToday,
  QueryBuilder,
} from '@material-ui/icons';
import moment from 'moment';
import { STATypeOptions } from '../../../utils/equipmentOptions';

import { OfflineRfsOrder, TruckingCompany } from '../../../models/OfflineRfs';
import RfsStyles from '../rfs.module.css';
import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>
  createStyles({
    truckInfoPaper: {
      padding: '24px 32px',
      marginTop: '24px',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
      backgroundColor: '#fff',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: '30px',
      width: '100%'
    },
    // wrapperwithborder: {
    //   boxShadow:
    //     '0px 1px 5px 2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    //   borderRadius: '4px',
    //   marginTop: '20px',
    //   justifyContent: 'space-between',
    //   maxWidth: '1300px',
    //   marginRight: 'auto',
    //   marginLeft: 'auto',
    //   flexWrap: 'wrap',
    //   '& > div': {
    //     margin: '0 0px',
    //   },
    // },
    sectionTitle: {
      color: 'var(--primaryblue)',
      fontWeight: 600,
      fontSize: '18px',
      marginBottom: '20px',
      borderBottom: '1px solid #eee',
      paddingBottom: '10px'
    },
    wrapper3: {
      width: '100% !important',
    },
    cdlwrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      '& span': {
        padding: '0 0 0 0',
        marginTop: '-3px',
        fontSize: '12px !important'
      },
      '& .MuiTypography-body2-146': {
        transform: 'translate(0, 3px) scale(1.10)',
        color: 'rgba(0, 0, 0, 0.54)',
        transformOrigin: 'top left',
        marginTop: '-7px',
      },
    },
    btnWrapper: {
      paddingTop: '16px',
    },
    materialIcon: {
      margin: '10px 3px 0',
      fontSize: 20,
      '&:hover': {
        cursor: 'pointer',
      },
    },
    materialIcon1: {
      marginTop: '-4px',
      paddingTop: 0,
      paddingBottom: 0,
      fontSize: 18,
      '&:path': {
        paddingLeft: '15px',
        paddingRight: '15px',
      },
      '&:hover': {
        cursor: 'pointer',
      },
    },
    materialIcon2: {
      fontSize: 20,
      '&:hover': {
        cursor: 'pointer',
      },
    },
    inputField:{
      fontSize: '13px',
      padding: '6px 12px',
    },
    inputWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    inputWrapper2: {
      display: 'flex',
      flexDirection: 'column',
      '& > div': { border: '1px solid rgba(170, 170, 170, 1)' },
      '& fieldset': { border: 'none' },
      '& input': {
        padding: '6px 5px 7px 5px',
        color: 'rgb(0, 50, 97)',
      },
    },
    staType: {
      fontSize: '0.8125rem',
      color: '#013261',
    },
    blue: {
      color: 'rgb(0, 50, 97)',
    },
    green: {
      color: '#70b602',
    },
    grey: {
      color: '#D7D7D7',
    },
    red: {
      color: '#d9001b',
    },
    datePicker: {
      width: 'calc(100% - 90px)',
      paddingRight: '12px',
      boxSizing: 'border-box',
      '& > div': {
        paddingRight: '1px',
      },
      '& > div::before': {
        border: 'none',
      },
      '& label': {
        width: '250px',
      },
    },
    dateWrapper: {
      display: 'flex',
    },
    dateWrap: {
      border: 'none !important',
    },
    ManagerTimer: {
      width: '90px',
      '&:before': {
        border: 'none',
      },
      '& > div': {
        paddingRight : '1px',
        '& select': {
          border: '1px solid rgba(170, 170, 170, 1)',
          textAlign: 'center',
          width: 'calc(100% - 32px)',
          paddingLeft: '5px',
        },
      },
    },
    datePickerInput: {
      '& input': {
        color: 'rgb(0, 50, 97)',
        textTransform: 'uppercase',
      },
      '& button': {
        padding: 0,
      },
    },
    timer: {
      marginTop: '16px',
      padding: '6px 0 7px',
      border: '1px solid rgba(170, 170, 170, 1)',
      paddingRight: '5px',
      '&:before': {
        border: 'none',
      },
      '& > div': {
        '& select': {
          border: '1px solid rgba(170, 170, 170, 1)',
          textAlign: 'center',
          width: 'calc(100% - 32px)',
          paddingLeft: '5px',
        },
      },
    },
    wrapperContainer: {
      marginTop: '14px',
    },
    truckTypeRadio: {
      '& > span': {
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: '4px'
      },
      '& p': {
        fontSize: '17px',
        color: '#003261',
        paddingLeft: '2px',
      },
    },
    filter: {
      marginLeft: '0px !important',
    },
    deleteDisable: {
      color: 'rgb(204, 204, 204)',
    },
    pr0: {
      paddingRight: '0px'
    },
    mt30: {
      marginTop: '30px'
    },
    adronment:{
      boxSizing: "border-box"
    },
    customButton: {
      textTransform: 'inherit',
      padding: '4px 18px',
    }
  });

interface TruckInfoProps {
  classes: any;
  handleChangeDate: (dateType: string, event: any) => void;
  handleChangeTime: (timeType: string, event: any) => void;
  orderInfo: OfflineRfsOrder;
  openDialog: (boxType: string, id?: number) => void;
  handleChange: (type: string, event: any) => void;
  handleUpdate: (type: string) => void;
  maskon: () => void;
  onClick: (event: any) => void;
  prefixPhoneNumber: string;
  truckersCompanyList: Array<TruckingCompany>;
  ghaOrigin?: string;
  handleFinalize: () => void;
}

const truckInfo = (props:TruckInfoProps) => {
  const { classes } = props;
  const staTypeOptions: Array<JSX.Element> = STATypeOptions.map(
    (item: { value: string; name: string }, index: number) => {
      return (
        <option key={index} value={item.value} className={ classes.staType }>
          {item.name}
        </option>
      );
    },
  );
  let colorsClass: string = classes.blue;

  const options: Array<JSX.Element> = props.truckersCompanyList.map(
    (item: any, index: number) => {
      return (
        <option key={index} value={item.id} className={ classes.staType }>
          {item.name}
        </option>
      );
    },
  );

  const finalize: any =	props.orderInfo.list !== undefined && props.orderInfo.list.length > 0;

  return (
    <React.Fragment>
      <div className={`${commonStyles.wrapper}` } >
        <h3 className={commonStyles.header}>
           Truck Details
        </h3>

        <Grid container className={ RfsStyles.truckinfoGridContainer } spacing={3}>
          <Grid item lg={2} md={3} sm={6} xs={12} className={ RfsStyles.truckinfoGriditem }>
            <div className={ classes.inputWrapper }>
              <label className={ commonStyles.inputLabel }>Drivers Name *</label>
              <div>
                <TextField
                  required
                  className={ classes.awbNumber }
                  id='driName'
                  value={props.orderInfo.driver_name}
                  onChange={(event) => props.handleChange('driverName', event)}
                  fullWidth
                  variant="outlined"
                  InputProps={{
                    classes: { input: classes.inputField, notchedOutline: RfsStyles.noNotch }
                  }}
                />
              </div>
            </div>
          </Grid>
        
          <Grid item lg={2} md={3} sm={6} xs={12} className={ RfsStyles.truckinfoGriditem }>
            <div className={ classes.inputWrapper }>
              <span className={ classes.cdlwrapper }>
                <label className={ commonStyles.inputLabel }>Drivers CDL *</label>
                <FormControlLabel
                  value='Hazmat'
                  control={
                    <Checkbox
                      checked={props.orderInfo.hazmat}
                      onChange={(event) => props.handleChange('hazmat', event)}
                      color='primary'
                    />
                  }
                  label='Hazmat'
                  labelPlacement='end'
                />
              </span>
              <TextField
                id='driverLicence'
                label=''
                className={ classes.paymentInfo }
                value={ props.orderInfo.maskedDriverId }
                onChange={ (event) => props.handleChange('driverLicence', event) }
                variant='outlined'
                onBlur={ props.maskon }
                onClick={ props.onClick }
                fullWidth
                InputProps={{
                  classes: { input: classes.inputField, notchedOutline: RfsStyles.noNotch }
                }}
              />
            </div>
          </Grid>
        
          <Grid item lg={2} md={3} sm={6} xs={12} className={ RfsStyles.truckinfoGriditem }>
            <div className={ [classes.inputWrapper, classes.selectFiel].join(' ') }>
              <label className={ commonStyles.inputLabel }>Select STA Type</label>
              <NativeSelect
                className={ classes.selectField }
                onChange={ (event) => props.handleChange('sta', event) }
                value={ props.orderInfo.sta ? props.orderInfo.sta : '' }
                input={ <OutlinedInput labelWidth={ 0 } classes={{ notchedOutline: RfsStyles.noNotch }} /> }
                >
                <option value={-1} className={ classes.staType } />
                { staTypeOptions }
              </NativeSelect>
            </div>
          </Grid>
        
          <Grid item lg={2} md={3} sm={6} xs={12} className={ RfsStyles.truckinfoGriditem }>
            <div className={ classes.inputWrapper }>
              <label className={ commonStyles.inputLabel }>Drivers Cell Phone *</label>
              <div className={ classes.awbWrap }>
                <TextField
                  className={ classes.awbNumber }
                  id='driPhone'
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start' >
                        {props.prefixPhoneNumber}
                      </InputAdornment>
                    ),
                    classes: { input: classes.inputField, notchedOutline: RfsStyles.noNotch, root: classes.adronment }
                  }}
                  value={
                    props.orderInfo.driver_contact
                      ? props.orderInfo.driver_contact.replace('+1', '')
                      : props.orderInfo.driver_contact
                  }
                  onChange={ (event) => props.handleChange('driverContact', event) }
                  fullWidth
                  variant="outlined"
                />
              </div>
            </div>
          </Grid>
          <Grid item lg={1} md={3} sm={6} xs={12} className={ RfsStyles.truckinfoGriditem }>
            <div className={ classes.inputWrapper}>
              <label className={ commonStyles.inputLabel }>Truck Plate *</label>
              <div className={ classes.awbWrap }>
                <TextField
                  className={ classes.awbNumber }
                  id='truckPlate'
                  value={ props.orderInfo.driver_vehichle_registration }
                  onChange={ (event) => props.handleChange('truckPlate', event) }
                  fullWidth
                  variant= "outlined"
                  InputProps={{
                    classes: { input: classes.inputField, notchedOutline: RfsStyles.noNotch }
                  }}
                />
              </div>
            </div>
          </Grid>
        
        <Grid item lg='auto' md={3} sm={6} xs={6} className={ RfsStyles.truckinfoGriditem }>
            <RadioGroup row name='isSealed'>
              <FormControlLabel
                value='locked'
                className={`${classes.truckTypeRadio} ${commonStyles.mr3}`}
                control={
                  <Radio
                    onChange={e => props.handleChange('locked', e)}
                    checked={props.orderInfo.locked}
                    icon={<RadioButtonUnchecked color='primary' />}
                    checkedIcon={<RadioButtonChecked color='primary' />}
                    size="small"
                    className={RfsStyles.radioIcon}
                  />
                }
                label={<span className={RfsStyles.radioLabel}>Locked</span>}
              />
              <FormControlLabel
                value='sealed'
                className={`${classes.truckTypeRadio}`}
                control={
                  <Radio
                    onChange={e => props.handleChange('sealed', e)}
                    checked={props.orderInfo.sealed}
                    icon={<RadioButtonUnchecked color='primary' />}
                    checkedIcon={<RadioButtonChecked color='primary' />}
                    size="small"
                    className={RfsStyles.radioIcon}
                  />
                }
                label={<span className={RfsStyles.radioLabel}>Sealed</span>}
              />
            </RadioGroup>
        </Grid>
        
          <Grid item lg md={3} sm={6} xs={12} className={ RfsStyles.truckinfoGriditem }>
            <div className={ classes.inputWrapper }>
                <>
                  <label className={ commonStyles.inputLabel }>Seal Number</label>
                  <div className={ classes.awbWrap }>
                    <TextField
                      className={ classes.awbNumber }
                      id='awbNumber'
                      disabled={!props.orderInfo.sealed}
                      value={ props.orderInfo.seal_number }
                      onChange={ (event) => props.handleChange('sealNumber', event) }
                      variant= "outlined"
                      InputProps={{
                        classes: { input: classes.inputField, notchedOutline: RfsStyles.noNotch }
                      }}
                      fullWidth
                    />
                  </div>
                </>
            </div>
          </Grid>
          
          <Grid item lg={2} md={3} sm={6} xs={12} className={ RfsStyles.truckinfoGriditem }>
            <div className={ classes.inputWrapper }>
              <span className={ classes.cdlwrapper }>
                <label className={ commonStyles.inputLabel }>Trucking Company *</label>
                <AddBox
                  color='primary'
                  className={ classes.materialIcon1 }
                  onClick={ (events) => props.openDialog('TcModal') }
                />
              </span>
              <FormControl>
                <NativeSelect
                  onChange={ (event) => props.handleChange('companyName', event) }
                  value={ props.orderInfo.id_delivery_company }
                  onClick={ props.onClick }
                  className={ classes.selectField }
                  input={ <OutlinedInput labelWidth={ 0 } classes={{ notchedOutline: RfsStyles.noNotch }} /> }
                  >
                  { options }
                </NativeSelect>
              </FormControl>
            </div>
          </Grid>

          <Grid item lg={2} md={3} sm={6} xs={12} className={ RfsStyles.truckinfoGriditem }>
            <div className={ classes.inputWrapper }>
              <label className={ commonStyles.inputLabel }>Billing Reference</label>
              <div className={ classes.awbWrap }>
                <TextField
                  className={ classes.awbNumber }
                  id='billRef'
                  value={
                    props.orderInfo.bill_to.full_address
                      ? props.orderInfo.bill_to.full_address
                      : ''
                  }
                  onChange={ (event) => props.handleChange('billRef', event) }
                  fullWidth
                  variant= "outlined"
                  InputProps={{
                    classes: { input: classes.inputField, notchedOutline: RfsStyles.noNotch }
                  }}
                />
              </div>
            </div>
          </Grid>

          <Grid item lg={2} md={3} sm={6} xs={6} className={ RfsStyles.truckinfoGriditem }>
            <div
              className={ classes.dateWrapper + ' ' + classes.inputWrapper }>
              <label className={ commonStyles.inputLabel }>Departure</label>
              <div className={ classes.dateWrap }>
                <KeyboardDatePicker
                  className={ classes.datePicker }
                  value={ props.orderInfo.departure_date }
                  format={'DD MMM YYYY'}
                  onChange={(date) =>
                    props.handleChangeDate('departureDate', date)
                  }
                  disabled={props.ghaOrigin === props.orderInfo.dst}
                  InputProps={{
                    className: classes.blue,
                    classes: { input: `${ classes.inputField } ${ classes.pr0 }`, notchedOutline: RfsStyles.noNotch }
                  }}
                  inputVariant='outlined'
                  fullWidth
                />
                <FormControl className= { classes.select }>
                  <InputLabel
                    htmlFor='scheduleTime'
                    className={ colorsClass }></InputLabel>
                  <TimePicker
                    format={'HH:mm'}
                    value={
                      props.orderInfo.departure_time
                        ? moment(props.orderInfo.departure_time, 'HH:mm')
                        : props.orderInfo.departure_time
                    }
                    onChange={(date) =>
                      props.handleChangeTime('departureTime', date)
                    }
                    className={ classes.ManagerTimer }
                    InputProps={{
                      className: classes.datePickerInput, 
                      classes: { input: `${ classes.inputField } ${ classes.pr0 }`, notchedOutline: RfsStyles.noNotch },
                      disableUnderline: true,
                    }}
                    disabled={ props.ghaOrigin === props.orderInfo.dst }
                    inputVariant='outlined'
                    autoOk
                  />
                </FormControl>
              </div>
            </div>
          </Grid>
        
          <Grid item lg={2} md={3} sm={6} xs={6} className={ RfsStyles.truckinfoGriditem }>
            <div
              className={ classes.dateWrapper + ' ' + classes.inputWrapper }>
              <label className={ commonStyles.inputLabel }>Arrival</label>
              <div className={ classes.dateWrap }>
                <KeyboardDatePicker
                  className={ classes.datePicker }
                  value={ props.orderInfo.arrival_date }
                  format={ 'DD MMM YYYY' }
                  onChange={ (date) => props.handleChangeDate('arrivalDate', date) }
                  InputProps={ { 
                    className: classes.blue,
                    classes: { input: `${ classes.inputField } ${ classes.pr0 }`, notchedOutline: RfsStyles.noNotch }
                  } }
                  disabled={ props.ghaOrigin !== props.orderInfo.dst }
                  inputVariant='outlined'
                />
                <FormControl className={ classes.select }>
                  <InputLabel
                    htmlFor='scheduleTime'
                    className={ colorsClass }></InputLabel>
                  <TimePicker
                    format={'HH:mm'}
                    value={
                      props.orderInfo.arrival_time
                        ? moment(props.orderInfo.arrival_time, 'HH:mm')
                        : props.orderInfo.arrival_time
                    }
                    onChange={(date) =>
                      props.handleChangeTime('arrivalTime', date)
                    }
                    className={ classes.ManagerTimer }
                    InputProps={ {
                      className: classes.datePickerInput,
                      classes: { input: `${classes.inputField} ${classes.pr0}`, notchedOutline: RfsStyles.noNotch },
                      disableUnderline: true,
                    } }
                    disabled={ props.ghaOrigin !== props.orderInfo.dst }
                    inputVariant='outlined'
                    autoOk
                  />
                </FormControl>
              </div>
            </div>
          </Grid>
      
          {props.ghaOrigin !== props.orderInfo.dst && 
            <Grid item lg md={3} sm={6} xs={6} className={ RfsStyles.truckinfoGriditem }>
              <div className={ classes.inputWrapper }>
                <label className={ commonStyles.inputLabel }>Origin Remarks</label>
                <div className={ classes.awbWrap }>
                  <TextField
                    className={ classes.awbNumber }
                    id='billRef2'
                    value={
                      props.orderInfo.org_comment
                        ? props.orderInfo.org_comment
                        : ''
                    }
                    onChange={ (event) => props.handleChange('org_remarks', event) }
                    variant= "outlined"
                    InputProps={{
                      className: classes.blue,
                      classes: { input: classes.inputField, notchedOutline: RfsStyles.noNotch }
                    }}
                    fullWidth
                  />
                </div>
              </div>
            </Grid>
          }
        
          { props.ghaOrigin === props.orderInfo.dst &&
            <Grid item lg md={3} sm={6} xs={6} className={ RfsStyles.truckinfoGriditem }>
              <div className={ classes.inputWrapper }>
                <label className={ commonStyles.inputLabel }>Destination Remarks</label>
                <div className={ classes.awbWrap }>
                  <TextField
                    className={ classes.awbNumber }
                    id='billRef2'
                    value={
                      props.orderInfo.dst_comment
                      ? props.orderInfo.dst_comment
                      : ''
                    }
                    onChange={ (event) => props.handleChange('dst_remarks', event) }
                    fullWidth
                    variant= "outlined"
                    InputLabelProps={{
                      className: classes.textField
                    }}
                    InputProps={{
                      className: classes.blue,
                      classes: { input: classes.inputField, notchedOutline: RfsStyles.noNotch }
                    }}
                  />
                </div>
              </div>
            </Grid>
          }
        
        </Grid>

        <div className={`${RfsStyles.truckBtnContainer} ${commonStyles.mt3}`} >
          <Button
            color='primary'
            variant='contained'
            onClick={() => props.handleUpdate('update')}
            disabled={ props.orderInfo.is_finalised }
            disableElevation
            className={ classes.customButton }>
            Update
          </Button>

          { props.ghaOrigin === props.orderInfo.dst &&
          <Button
            color='primary'
            variant='contained'
            onClick={ props.handleFinalize }
            disabled={ props.orderInfo.is_finalised || !finalize }
            disableElevation
            className={ classes.customButton + ' ' + classes.finalise }>
            Finalize
          </Button> }
        </div>
      </div>
    </React.Fragment>
  );
};

export default withStyles(styles)(truckInfo);
